﻿import $ from 'jquery';
import { IBinder, IBehaviorBinding, ICellBinding } from "./ibinder";

export class CheckAllBinder implements IBinder {
  public getElements(root: JQuery): JQuery {
    return root.find("th input[type='checkbox']");
  }

  public getBinding(element: JQuery): IBehaviorBinding {
    var bindTo = "checkAll.bind($data)";

    return {
      bindingName: "click",
      bindTo: bindTo,
      behavior: {
        name: "checkAll",
        build: data => (data, event) => {
          var checkbox = $(event.currentTarget);
          var isChecked = checkbox.is(":checked");
          var table = $('table[data-et-key="' + data.tableKey + '"]');
          var checkboxIndex = table.find("thead th").index(checkbox.parent("th"));

          var firstRow = table.find("tbody tr").eq(0);
          var column = firstRow.find("td").eq(checkboxIndex);
          var valueName = column.find("input[type='checkbox']").attr("name").split(".")[1];

          data.Rows().forEach(v => {
            v[valueName].call(this, isChecked);
          });

          return true;
        }
      }
    }
  }
}
